import React, { useState } from "react";
import { Badge, Dropdown, List } from "antd";
import { BellOutlined } from "@ant-design/icons";

const HeaderNotifications: React.FC = () => {
  const [notifications] = useState<any[]>([
    { title: "No new notifications" }
  ]); // start with empty

  const menu = (
    <div
      style={{
        width: 280,
        maxHeight: 400,
        overflowY: "auto",
        background: "#fff",
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        padding: 8,
        zIndex: 3000,
      }}
    >
      <List
        itemLayout="horizontal"
        dataSource={notifications}
        locale={{ emptyText: "No new notifications" }}
        renderItem={(item) => <List.Item>{item.title}</List.Item>}
      />
    </div>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight" arrow>
      <Badge count={0} offset={[-5, 5]}>
        <BellOutlined style={{ fontSize: 20, cursor: "pointer" }} />
      </Badge>
    </Dropdown>
  );
};

export default HeaderNotifications;
